import {
  BookSegment,
  GetListResponse,
  LabelValue,
  RequestParamsBookSegment,
  UpdateBookSegmentRequest,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestContentType, Signal } from "@core/services/http/http.type";

class _BookSegmentService {
  public getBookDropdown(keyword?: string, signal?: Signal) {
    return HttpService.get<GetListResponse<LabelValue>>(
      "/admin/api/v2/dashboard/book-dropdown",
      {
        queryParams: { keyword },
        signal,
      }
    );
  }

  public getBookElementDropdown(
    bookId: number,
    keyword?: string,
    signal?: Signal
  ) {
    return HttpService.get<GetListResponse<LabelValue>>(
      `/admin/api/v2/dashboard/book-element-dropdown/${bookId}`,
      {
        queryParams: { keyword },
        signal,
      }
    );
  }

  public getList(requestParams?: RequestParamsBookSegment, signal?: Signal) {
    return HttpService.get<GetListResponse<BookSegment>>(
      "/admin/api/v2/book-segments",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public update(
    bookSegmentId: number,
    updateBookSegmentRequest: UpdateBookSegmentRequest
  ) {
    return HttpService.patch(`/admin/api/v2/book-segments/${bookSegmentId}`, {
      body: { ...updateBookSegmentRequest },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public delete(bookSegmentId: number) {
    return HttpService.delete(`/admin/api/v2/book-segments/${bookSegmentId}`);
  }
}

const BookSegmentService = new _BookSegmentService();

export default BookSegmentService;
